export default "__VITE_ASSET__CbZl3tHa__"